import useSWR from 'swr'
import API from '../../../utils/api'
import { getPersistData } from '../../hooks/persist'
import { useToken } from 'app/hooks'

const KEY = '/schedule' // Schedule API

let swrData: any = getPersistData(KEY)

export function useSchedule(startDate?: string, endDate?: string) {
	const { data: token } = useToken()
	
	const queryParams = new URLSearchParams()
	if (startDate) queryParams.append('startDate', startDate)
	if (endDate) queryParams.append('endDate', endDate)
	queryParams.append('page', '1')
	queryParams.append('maxData', '1000')
	
	const queryString = queryParams.toString()
	const fullKey = `${KEY}?${queryString}`
	
	const { data, mutate } = useSWR<any>(
		fullKey,
		async () => {
			const response = await API.get(fullKey, token + '', {})
			swrData = response.result?.list || []

			return swrData
		},
		{ revalidateOnFocus: true }
	)

	return {
		ScheduleData: data,
		mutate: (value?: any) => {
			if (value != undefined) {
				swrData = value
			}
			return mutate()
		},
	}
}







